import React, { FC } from 'react'
import { slugs } from '@/constants/slugs'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { useLocale } from '@/utils/LocaleUtil'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'

export const GiveawaySeo: FC = () => {
  const { sweepstake, theatricalSlug } = useGiveawayContext()
  const { locale } = useLocale()
  const { t } = useTranslate('tickets')

  const { seoImageUrl, projectName } = sweepstake

  const title =
    theatricalSlug === slugs.homesteadSeries
      ? t('giveawaySeoTitleHomesteadSeries', 'Watch Homestead to Enter to Win', {
          projectName,
        })
      : t('giveawaySeoTitleAngel', 'PRE-ORDER {{projectName}} Tickets | Angel', {
          projectName,
        })

  const description =
    theatricalSlug === slugs.homesteadSeries
      ? t(
          'giveawaySeoDescriptionHomesteadSeries',
          'Watch Homestead for a Chance to Win the Season 1 Escape and Evade Giveaway!',
          {
            projectName,
          },
        )
      : t('giveawaySeoDescription', 'Buy {{projectName}} tickets for a Chance to Win the Giveaway!', {
          projectName,
        })

  return (
    <Seo
      {...getBasicPageMetaData({
        cloudinaryImagePath: seoImageUrl ?? '',
        cloudinaryTransformation: 'b_rgb:000000,c_fill',
        title,
        description,
        locale,
        path: `/giveaway/${theatricalSlug}`,
      })}
      // PreSalesGiveawayView is deprecated, so we need to noindex the pages
      noindex
    />
  )
}
